import {Injectable} from '@angular/core';
import {VwLabBenchmarkGuest} from '../../../models/vwLabBenchmarkGuest';
import { VwLabBenchmark } from 'src/app/models/VwLabBenchmark';

@Injectable({
  providedIn: 'root'
})
export class BenchmarkStore {
  title = 'Benchmark';
  showLoader: boolean;
  viewAllPath = '/menu/viewall/benchmark';

  records: VwLabBenchmark[];
  sortedRecords: VwLabBenchmark[];

 // isGuest:boolean=true;

  recordsGuest: VwLabBenchmarkGuest[];
  sortedRecordsGuest: VwLabBenchmarkGuest[];
  totalRecords: number;


  constructor() {
    this.records = [];
    this.sortedRecords = [];
  }

  load(records: VwLabBenchmark[]) {
    // TODO: sorting here
    this.records = records;
    this.sortedRecords = this.records.slice();
  }

  loadGuest(records: VwLabBenchmarkGuest[]) {
    // TODO: sorting here
    this.recordsGuest = records;
    this.sortedRecordsGuest = this.recordsGuest.slice();
  }
}
